import React from 'react';
import { Tag } from 'antd';

const StrongTag = ( { text, strontText, color = 'blue', onCloseCallback, tagKey, className } ) => {
    return (
        <Tag
            className={ className }
            key={ tagKey }
            color={ color }
            onClose={ onCloseCallback }
            closable={ onCloseCallback }
        >
            <strong>{ strontText }</strong>
            { text }
        </Tag>
    );
};

export default StrongTag;
